import {Fancybox} from "@fancyapps/ui";

const geolocation = () => {

	const geoBtnRegionYes = document.querySelector(".geo_btn-region-yes");
	geoBtnRegionYes?.addEventListener("click", () => {
		const regFixId = geoBtnRegionYes.dataset.regid;
		if (regFixId) updateRegion(regFixId);
	});

	const formControlSelectGeo2 = document.querySelector(".form-control_select-geo2");
	formControlSelectGeo2?.addEventListener("change", () => {
		const regId = formControlSelectGeo2.value;
		if (regId) updateRegion(regId);
	});

	// $("#idlinkregfix").click(function(){
	// 	$("#iddivselectregion").show();
	// })
}

window.geoShowPopup = () => {
	try {
		const geoModalContent = document.querySelector('.geo__modal-wrapper')?.innerHTML;
		if (!geoModalContent) throw new Error('Geolocation modal content not found');

		new Fancybox(
			[{
				src: geoModalContent,
				type: "html"
			}],
			{
				dragToClose: !window.isMobile, // bug: click to button misses on mobile
				on: {
					reveal: () => {
						const formControlSelectGeo = document.querySelector('.fancybox__content .form-control_select-geo');
						formControlSelectGeo?.addEventListener('change', () => {
							const regId = formControlSelectGeo.value;
							if (regId) updateRegion(regId);
						});
					}
				}
			}
		);
	} catch (err) {
		console.error('Error initializing Fancybox geolocation:', err);
	}
}

const updateRegion = (regId) => {
	window.location.href = `/?change_region=${regId}`;
};

export default geolocation;